__turbopack_context__.v({
  "StoreDetails": "StoreDetails-module__m-8Wqq__StoreDetails",
  "active": "StoreDetails-module__m-8Wqq__active",
  "body": "StoreDetails-module__m-8Wqq__body",
  "button": "StoreDetails-module__m-8Wqq__button",
  "callNow": "StoreDetails-module__m-8Wqq__callNow",
  "changer": "StoreDetails-module__m-8Wqq__changer",
  "contents": "StoreDetails-module__m-8Wqq__contents",
  "description": "StoreDetails-module__m-8Wqq__description",
  "header": "StoreDetails-module__m-8Wqq__header",
  "image": "StoreDetails-module__m-8Wqq__image",
  "imageList": "StoreDetails-module__m-8Wqq__imageList",
  "left": "StoreDetails-module__m-8Wqq__left",
  "mainImage": "StoreDetails-module__m-8Wqq__mainImage",
  "right": "StoreDetails-module__m-8Wqq__right",
  "row": "StoreDetails-module__m-8Wqq__row",
  "subtitle": "StoreDetails-module__m-8Wqq__subtitle",
  "text": "StoreDetails-module__m-8Wqq__text",
  "title": "StoreDetails-module__m-8Wqq__title",
  "value": "StoreDetails-module__m-8Wqq__value",
  "xl": "StoreDetails-module__m-8Wqq__xl",
});
